<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'app',
  components:{
  },
  data() {
    return {
    };
  },
  computed: {

  },
  mounted() {
    
  },
  created(){
  },
  activated(){
    
    
  },
  methods:{
    
    
  }
};
</script>

<style lang="less">
body {
  // background-color: #f5f7fb;
  background-color: #fff;;
  font-family: Microsoft YaHei, Arial, Helvetica, sans-serif !important;
}

#app {
  font-style: normal;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>
